var _defs, _g, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdminPortalNotepad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .b {\n        fill: #fff;\n      }\n\n      .c {\n        fill: #6f3d90;\n      }\n\n      .d {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 150,
    cy: 150,
    r: 120
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "177.85 204.19 177.85 184.27 197.77 184.27"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "178.81 102.84 197.77 102.84 197.77 184.27 177.85 204.19 96.42 204.19 96.42 102.84 173.93 102.84"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 116.07,
    y1: 132.02,
    x2: 144.96,
    y2: 132.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 116.07,
    y1: 142.77,
    x2: 178.12,
    y2: 142.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 116.07,
    y1: 153.51,
    x2: 178.12,
    y2: 153.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 116.07,
    y1: 164.26,
    x2: 178.12,
    y2: 164.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 116.07,
    y1: 175.01,
    x2: 178.12,
    y2: 175.01
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "197.77 108.65 203.58 108.65 203.58 210 102.23 210 102.23 204.19"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M189.49,122.9c0,4.3-3.49,7.78-7.78,7.78s-7.78-3.49-7.78-7.78v-25.12c0-4.3,3.49-7.78,7.78-7.78s7.78,3.49,7.78,7.78v5.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M178.81,120.25v-21.85c0-1.6,1.3-2.9,2.9-2.9s2.9,1.3,2.9,2.9v4.51"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 112.67,
    y: 152.59,
    width: 75.02,
    height: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminPortalNotepad);
export default __webpack_public_path__ + "static/media/admin_portal_notepad.2b1ff127fcfb468c896cffa6cdf11647.svg";
export { ForwardRef as ReactComponent };